import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  Badge,
} from "react-bootstrap";
import Founder from "../../assets/images/founder.jpeg";
import Cofounder from "../../assets/images/cofounder.jpeg";
import { FaBullseye, FaQuoteLeft } from "react-icons/fa";

function AboutUs() {
  return (
    <Container className="about-us-page my-5">
      {/* Page Header */}
      <Row className="text-center mb-5">
        <Col>
          <p className="fw-bold">ABOUT US</p>
          <h3 className="fw-bold font-red">
            Building legacies rooted in trust, sustainability, and enduring relationships
          </h3>        
        </Col>
      </Row>

      {/* Founder Profile */}
      <Row className="mb-5 align-items-start">
        <Col lg={4} md={5} className="mb-4">
          <Card className="border-0 shadow-sm">
            <img
              src={Founder}
              alt="R. Jeyakumar"
              className="img-fluid rounded-top"
            />
            <Card.Body className="text-center">
              <h5 className="fw-bold mb-1 font-red">R. Jeyakumar</h5>
              <p className="mb-2 font-red">M.E. (Structural Engineering)</p>
              <Badge bg="secondary">44+ Years Experience</Badge>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={8} md={7}>
          <h3 className="fw-bold mb-1 font-red">
            Founder & Director – Rajparis Group
          </h3>
          <h6 className="text-muted mb-4">
            Rajparis Redevelopment & Constructions (RRD)
          </h6>

          <Card className="border-0 shadow-sm mb-4">
            <Card.Body>
              <p className="rrd-para-justify">
                R. Jeyakumar is a postgraduate in Structural Engineering from the
                College of Engineering, Guindy (CEG), Anna University, with over
                <b> 44 years of rich and hands-on experience</b> in the construction
                and real-estate development industry.
              </p>

              <p className="rrd-para-justify">
                An environmentally conscious professional and a pioneer of rainwater
                harvesting in Tamil Nadu, Mr. Jeyakumar was among the early advocates
                who actively promoted and implemented rainwater harvesting practices
                long before they became mandatory. Sustainability, responsible
                development, and long-term impact have always been integral to his
                professional philosophy.
              </p>

              <p className="rrd-para-justify">
                He is the Co-Founder and Director of Rajparis Civil Constructions,
                a name synonymous with quality, trust, and enduring client
                relationships. Over four decades, he has successfully delivered
                numerous residential and commercial projects that continue to stand
                as benchmarks of thoughtful planning and structural integrity.
              </p>
            </Card.Body>
          </Card>


          {/* Contributions Accordion */}
          <h5 className="fw-bold mb-3 font-red">Professional & Academic Contributions</h5>
          <Accordion flush alwaysOpen defaultActiveKey={["0", "1"]}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Professional Bodies</Accordion.Header>
              <Accordion.Body>
                <ul className="mb-0">
                  <li>Patron Member, Builders’ Association</li>
                  <li>Skill Development Chairman, CREDAI Chennai</li>
                  <li>Executive Committee Member, Indian Building Congress (IBC)</li>
                  <li>Executive Committee Member, Indian Concrete Institute (ICI)</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>Academic Institutions</Accordion.Header>
              <Accordion.Body>
                <ul className="mb-0">
                  <li>Member, Board of Studies – Anna University</li>
                  <li>SRM Institute of Science & Technology</li>
                  <li>Crescent University</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* <Card className="border-0 bg-light mt-4">
            <Card.Body>
              <p className="mb-0">
                Deeply passionate about training and mentoring young engineers,
                he actively contributes to academic institutions and professional
                forums, bridging the gap between theory and real-world practice.
              </p>
            </Card.Body>
          </Card> */}
        </Col>
      </Row>
      <Row>
        <div className="mission-quote-band my-5">
            <Container>
                <Row className="align-items-center text-center text-lg-start">
                
                {/* Mission */}
                <Col lg={6} className="mb-4 mb-lg-0">
                    <div className="mission-box">
                    <h5 className="fw-bold text-uppercase mb-3">
                        <FaBullseye className="me-2" />
                        The RRD Mission
                    </h5>
                    <p className="mb-0 fst-italic">
                        To redevelop aging apartments originally built by Rajparis,
                        preserving emotional value while upgrading them to
                        contemporary standards.
                    </p>
                    </div>
                </Col>

                {/* Quote */}
                <Col lg={6}>
                    <div className="quote-box">
                    <FaQuoteLeft className="quote-icon mb-3" />
                    <p className="fst-italic mb-0">
                        “Buildings may be made of concrete, but enduring legacies are
                        built on trust.”
                    </p>
                    <p className="fw-semibold mt-2 mb-0">
                        — R. Jeyakumar, Founder & Director
                    </p>
                    </div>
                </Col>

                </Row>
            </Container>
            </div>
      </Row>

      {/* Partner Section */}
      <Row className="mt-5">
        <Col>
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <Row className="align-items-center">
                {/* <Col lg={3} className="text-center mb-3 mb-lg-0">
                  <div
                    className="rounded-circle bg-red text-white d-flex align-items-center justify-content-center mx-auto"
                    style={{ width: 120, height: 120 }}
                  >
                    <h1 className="mb-0">DR</h1>
                  </div>
                </Col> */}
                <Col lg={4} md={5} className="mb-4">
                  <Card className="border-0 shadow-sm">
                    <img
                      src={Cofounder}
                      alt="Dr. Rajeshwari Raju"
                      className="img-fluid rounded-top"
                    />
                    <Card.Body className="text-center">
                      <h5 className="fw-bold mb-1 font-red">Dr. Rajeshwari Raju</h5>
                      <p className="mb-2 font-red">Partner – Rajparis Redevelopment & Constructions</p>
                      {/* <Badge bg="secondary">44+ Years Experience</Badge> */}
                    </Card.Body>
                  </Card>
                </Col>


                <Col lg={8}>
                  <h3 className="fw-bold font-red">Dr. Rajeshwari Raju</h3>
                  <h6 className="text-muted mb-3">
                    Partner – Rajparis Redevelopment & Constructions
                  </h6>

                  <p className="rrd-para-justify">
                    Dr. Rajeshwari Raju, a Child Specialist by profession, brings a
                    unique blend of professional excellence, integrity, and values
                    into the Rajparis family business. Her medical career reflects
                    compassion and commitment to service, while her association with
                    Rajparis strengthens the organisation’s ethical foundation.
                  </p>

                  <p className="rrd-para-justify">
                    She plays an active role in decision-making across Rajparis Civil
                    Constructions and Rajparis Redevelopment & Constructions, ensuring
                    transparency, responsibility, and respect for customer trust.
                  </p>

                  <p className="mb-0 rrd-para-justify">
                    Known for her financial discipline and principled outlook,
                    Dr. Rajeshwari Raju ensures that commitments made to customers
                    are honoured with sincerity and care, adding stability and depth
                    to the leadership of RRD.
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default AboutUs;
